import { useInfiniteScrollResults } from 'libs/searchspring/hooks/useInfiniteScrollResults'

export function ProductCount() {
  const { results } = useInfiniteScrollResults()
  const totalResults = results?.pagination?.totalResults || 0

  return (
    <div className="text-xs lg:text-s text-neutral-secondary">
      {totalResults === 0
        ? 'No Products'
        : totalResults === 1
          ? '1 Product'
          : `${totalResults.toLocaleString()} Products`}
    </div>
  )
}
